export default __webpack_public_path__ + "static/media/beer-mobile.988222cd.png";